module.exports = __webpack_public_path__ + "static/media/foto1.c8e87ee1.png";